import { useAuth } from "@/hooks/useAuth";
import { Navigate } from "react-router-dom";
import { logger } from "@/lib/logger";
import { Skeleton } from "@/components/shared/ui/skeleton";

type PublicRouteProps = {
  children: React.ReactNode;
};

export const PublicRoute = ({ children }: PublicRouteProps) => {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="space-y-3 w-48">
          <Skeleton className="h-6 w-full" />
          <Skeleton className="h-4 w-3/4" />
        </div>
      </div>
    );
  }

  if (user && profile) {
    const path = typeof window !== "undefined" ? window.location.pathname : "";

    // Allow authenticated users to access the password reset page
    // because Supabase may sign them in during the recovery flow.
    if (path === "/reset-password") {
      logger.debug(
        "Authenticated user accessing reset-password - allowing route"
      );
      return <>{children}</>;
    }

    logger.debug("Redirecting to dashboard - user authenticated", {
      role: profile.role,
    });
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};
